import ApiService from './api.service'

const GamePhotosService = {
  index (filter) {
    return ApiService.get('api/scorekeeper/photos', {
      params: {
        filter
      }
    })
  },
  show (gameUuid) {
    return ApiService.get(`api/scorekeeper/photos/${gameUuid}`)
  },
  players (gameUuid) {
    return ApiService.get(`api/scorekeeper/photos/${gameUuid}/players`)
  },
  playerPhotosGames () {
    return ApiService.get('api/scorekeeper/player-photos')
  },
  searchPlayerPhotos (search) {
    return ApiService.get('api/scorekeeper/player-photos/search', { params: { search } })
  }
}

export default GamePhotosService
